import { coalesceLocaleField } from '../helpers/coalesceLocaleField'
import { groq } from 'next-sanity'
import { LocaleId } from '@magal/configs'
import { createLinkProjection } from '../projections/createLinkProjection'
import { createBlockContentProjection } from '../projections/createBlockContentProjection'
import { createMediaProjection } from '../projections/createMediaProjection'

export const createSectionSampleProjection = (localeId: LocaleId) => {
  const LINK_PROJECTION = createLinkProjection(localeId)
  const MEDIA_PROJECTION = createMediaProjection(localeId)
  const BLOCK_CONTENT_PROJECTION = createBlockContentProjection(localeId)

  return groq`{
    _key,
    _type,
    ${coalesceLocaleField('title', localeId)},
    ${coalesceLocaleField('content', localeId)}[]${BLOCK_CONTENT_PROJECTION},
    ctaLink${LINK_PROJECTION},
    ${coalesceLocaleField('ctaLabel', localeId)},
    imageSampleField${MEDIA_PROJECTION},
    videoSampleField${MEDIA_PROJECTION},
  }`
}
